import get from "lodash/get";

export const getFormErrorMessage = (e, listFieldErrors) => {
  console.log(e);
  let fieldErrors = get(e, "response.data.errors", null);
  if (fieldErrors && !listFieldErrors){
    // do not show the names of the fields
    return '';
  }
  let jsonData = JSON.stringify(get(e, "response.data", null));
  return JSON.stringify(get(e, "response.data.message", get(e, "response.data.errors", jsonData || "Error"))).slice(0, 300);
};


// WEBPACK FOOTER //
// ./src/utils/errorHandler.js